import { useTranslation } from 'react-i18next'

import { FormBody, FormFieldsContainer } from '../../../../../../Form'
import { FormikField } from '../../../../../../Formik'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../../../../../Icon'
import { InputField } from '../../../../../../Input'
import { Content } from '../../../../../../Modal'
import Text from '../../../../../../Text'
import { TextareaOutlineField } from '../../../../../../Textarea'
import { getApplicantFitCheckThrottleLine } from '../../ApplicantFitCheckBlockRequestRow'
import {
  MATCH_REQUEST_FIELD_NAME_MESSAGE,
  MATCH_REQUEST_FIELD_NAME_SUBJECT,
  MATCH_REQUEST_MESSAGE_MIN_ROWS,
} from '../ApplicantFitCheckRequestModal.constants'

import * as styles from './ApplicantFitCheckRequestModalFields.module.css'

import InformationIcon from '../../../../../../../icons/info.svg'

function ApplicantFitCheckRequestModalFields({
  informationText,
  match,
  reference,
  onCancel,
}) {
  const { t } = useTranslation()

  const throttleLine = getApplicantFitCheckThrottleLine({ match, t })

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        UploadComponent: false,
        cancelProps: { onClick: onCancel },
        children: throttleLine ? (
          <Text isSecondary className={styles.throttle}>
            {throttleLine}
          </Text>
        ) : null,
        className: styles.actions,
        submitProps: { title: 'RentalPortal.MatchRequestSendBtnKey' },
      }}
    >
      <Content>
        <FormFieldsContainer>
          <div className={styles.recipient}>
            <Text isSecondary>{t('RentalPortal.MatchRequestToLabelKey')}</Text>
            <Text className={styles.recipientValue}>
              {t('RentalPortal.ApplicantIdentityReferenceKey', {
                ref: reference,
              })}
            </Text>
            <IconWithTooltip
              Icon={InformationIcon}
              className={styles.recipientHint}
              size={ICON_HEIGHT_16}
              svgSize={ICON_HEIGHT_16}
              tooltip={t('RentalPortal.MatchRequestToHintKey')}
            />
          </div>
          <FormikField
            Component={InputField}
            fieldComponentProps={{
              label: t('RentalPortal.MatchRequestSubjectLabelKey'),
            }}
            name={MATCH_REQUEST_FIELD_NAME_SUBJECT}
          />
          <FormikField
            autoResizeHeight
            Component={TextareaOutlineField}
            fieldComponentProps={{
              label: t('RentalPortal.MatchRequestMessageLabelKey'),
            }}
            minRows={MATCH_REQUEST_MESSAGE_MIN_ROWS}
            name={MATCH_REQUEST_FIELD_NAME_MESSAGE}
          />
          {informationText ? (
            <div className={styles.informationText}>
              <Text isSecondary className={styles.informationTextLabel}>
                {t('RentalPortal.MatchRequestInformationTextLabelKey')}
              </Text>
              <Text isSecondary>{informationText.text}</Text>
            </div>
          ) : null}
        </FormFieldsContainer>
      </Content>
    </FormBody>
  )
}

export default ApplicantFitCheckRequestModalFields
